import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import LoadProfileRouteInfoLineup from "./LoadProfileRouteInfoLineup/LoadProfileRouteInfoLineup";
import LoadProfileRouteInfoRow from "./LoadProfileRouteInfoRow/LoadProfileRouteInfoRow";

export default function LoadProfileRouteInfo({
  activeLoad,
  stopsUpdated,
  setStopsUpdated,
  handleUpdateStops,
  isLoading,
  clearTimeFromStops
}) {
  const [stops, setStops] = useState([]);

  useEffect(() => {
    if (activeLoad.stops) {
      setStops(activeLoad.stops);
    }
  }, [activeLoad]);

  return (
    <Box sx={{ display: "flex", padding: "0 30px" }}>
      <Box display="flex">
        <LoadProfileRouteInfoLineup stops={stops} />
      </Box>
      <Box sx={{ flexGrow: 1 }}>
        {stops.map(stop => (
          <LoadProfileRouteInfoRow
            key={`stop-${stop.id}`}
            stop={stop}
            brokerageStatus={activeLoad.brokerageStatus}
            bolNumber={activeLoad.blnum}
            conNumber={activeLoad.consigneeRefNum}
            stopsUpdated={stopsUpdated}
            setStopsUpdated={setStopsUpdated}
            handleUpdateStops={handleUpdateStops}
            clearTimeFromStops={clearTimeFromStops}
            isLoading={isLoading}
          />
        ))}
      </Box>
    </Box>
  );
}

LoadProfileRouteInfo.propTypes = {
  activeLoad: PropTypes.object.isRequired,
  stopsUpdated: PropTypes.array,
  setStopsUpdated: PropTypes.func,
  handleUpdateStops: PropTypes.func,
  isLoading: PropTypes.bool,
  clearTimeFromStops: PropTypes.func
};